import './index.css';

export default {
  name: 'Arotate',
  props: {
    id: { type: String, default: () => (`a-rotate-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 20 }, // 旋转速度(值越小越快)
    pause: { type: Boolean, default: () => false }, // 是否暂停
    reverse: { type: Boolean, default: () => false }, // 是否反转
    opacity: { type: Number | String, default: () => 1 }, // 最小透明度
    data: {
      type: Array,
      default: () => [
        { text: '一', code: '1' },
        { text: '二', code: '2' },
        { text: '三', code: '3' },
        { text: '四', code: '4' },
        { text: '五', code: '5' },
        { text: '六', code: '6' },
        { text: '七', code: '7' },
        { text: '八', code: '8' },
        { text: '九', code: '9' },
        { text: '十', code: '10' },
        { text: '十一', code: '11' },
        { text: '十二', code: '12' },
        { text: '十三', code: '13' },
        { text: '十四', code: '14' },
        { text: '十五', code: '15' },
        { text: '十六', code: '16' },
        { text: '十七', code: '17' },
        { text: '十八', code: '18' },
        { text: '十九', code: '19' },
        { text: '二十', code: '20' },
      ]
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    const { size = 75 } = this.$attrs;
    const perimeter = (Math.PI * 2); // 容器的圆周率长
    const list = this.options || this.option || this.config || this.items || this.data || [];
    const angle = (perimeter / list.length); // 元素的平均角度
    return ({
      list,
      size,
      width: null,
      height: null,
      innerWidth: null,
      innerHeight: null,
      animation: null,
      stop: this.pause, // 暂停
      clientX: 0, // 鼠标按下的位置
      position: 0, // 当前移动的位置
      perimeter,
      angle,
    });
  },
  watch: {
    data: { deep: true, immadiate: true, handler() { this.create() } },
    items: { deep: true, immadiate: true, handler() { this.create() } },
    config: { deep: true, immadiate: true, handler() { this.create() } },
    option: { deep: true, immadiate: true, handler() { this.create() } },
    options: { deep: true, immadiate: true, handler() { this.create() } },
    pause(state) {
      this.stop = state;
      this.$nextTick(() => this.enable());
    },
  },
  computed: {
    array() {
      return this.list.map((a, b) => {
        const angle = ((b * this.angle) + this.position);
        const sin = Math.sin(angle); // 正弦
        const cos = Math.cos(angle); // 余弦
        const width = (this.innerWidth / 2);
        const height = (this.innerHeight / 2);
        const x = (((sin * width) + width) - (this.size / 2));
        const y = (((cos * height) + height) - (this.size / 2));
        const stage = ((cos + 1) / 2).toFixed(2);
        const zIndex = (stage * 100);
        const opacity = Math.max(stage, Number(this.opacity));
        const scale = Math.max(stage, (height / width).toFixed(2), 0.5);
        return ({
          ...a,
          style: {
            zIndex,
            opacity,
            width: (`${this.size}px`),
            height: (`${this.size}px`),
            transform: (`translate3d(${x}px, ${y}px, 0) scale(${scale})`),
          },
        });
      });
    },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        !this.width && (this.width = this.$el.clientWidth);
        !this.height && (this.height = this.$el.clientHeight);
        this.$nextTick(() => {
          !this.size && (this.size = (this.height * 0.1));
          this.$nextTick(() => {
            !this.innerWidth && (this.innerWidth = (this.width - this.size));
            !this.innerHeight && (this.innerHeight = (this.height - this.size));
            this.$nextTick(() => this.array && this.array.length > 0 && this.enable());
          });
        });
      });
    },
    moving() {
      this.position += (Math.min((0.1 / parseInt(this.speed)), 0.05) * (this.reverse ? -1 : 1));
      if (Math.abs(this.position) >= this.perimeter) {
        this.position = 0;
      }
      this.$nextTick(() => this.$emit('moving', this.position));
    },
    enable() {
      if (this.animation) {
        this.cancel();
      } else if (this.stop === false) {
        const animation = () => {
          this.moving();
          this.$nextTick(() => this.animation = requestAnimationFrame(animation));
        }
        animation();
      }
    },
    cancel() {
      if (this.animation) {
        cancelAnimationFrame(this.animation);
        this.animation = null;
      }
    },
    assign() {
      this.$el.addEventListener('mousemove', this.mousemove);
    },
    remove() {
      this.$el.removeEventListener('mousemove', this.mousemove);
    },
    mouseenter(a) {
      a.preventDefault();
      this.cancel();
    },
    mousedown(a) {
      a.preventDefault();
      this.clientX = a.clientX;
      this.$nextTick(() => this.assign());
    },
    mousemove(a) {
      a.preventDefault();
      this.position = ((a.clientX - this.clientX) / 200);
    },
    mouseup(a) {
      a.preventDefault();
      this.remove();
    },
    mouseleave(a) {
      a.preventDefault();
      this.remove();
      this.$nextTick(() => this.enable());
    },
    click(a, b) {
      this.$emit('click', a, b);
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => this.remove());
    },
  },
  render() {
    const { width = '100%', height = '100%', padding, margin, border = true } = this.$attrs;
    return (
      <div
        id={this.id}
        class={['a-rotate', (border ? 'border' : null)]}
        on-mouseenter={this.mouseenter}
        on-mousedown={this.mousedown}
        on-mouseup={this.mouseup}
        on-mouseleave={this.mouseleave}
        style={{ width, height }}
      >
        {this.$slots.default && (<div class="a-rotate-core">{this.$slots.default}</div>)}
        <div class="a-rotate-main" style={{ width: (`${this.width}px`), height: (`${this.height}px`), padding, margin }}>
          <div class="a-rotate-body" style={{ width: (`${this.innerWidth}px`), height: (`${this.innerHeight}px`) }}>
            <div class="a-rotate-line" />
            {this.array && this.array.length > 0 && (this.array.map((a, b) => {
              const label = a.label || a.title || a.text || a.name || a;
              const element = a.components || a.component || a.formatter || a.element || a.format || a.render || a.dom || null;
              return (
                <div key={b} class={['a-rotate-item', (`item-${b + 1}`)]} on-click={() => this.click(a, b)} style={a.style}>
                  {element || label}
                </div>
              );
            }))}
          </div>
        </div>
      </div>
    );
  },
}